import React, { useEffect, useRef, memo } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

/**
 * Tooltip component. **Warn** It is not really implemented.
 *
 * @param props {Object}.
 * @param props.content {string}.
 * @param props.children {*}.
 * @param props.position {string}.
 */
const DataToolTip = ({ content, position = 'top', children }) => {
  const spanRef = useRef(null);

  useEffect(() => {
    const element = spanRef.current;

    if (!element) return;

    $(element).tooltip();

    return () => {
      $(element).tooltip('hide');
      $(element).tooltip('destroy');
    };
  }, []);

  return (
    <span ref={spanRef} data-placement={position} data-toggle="tooltip" title={content}>
      {children}
    </span>
  );
};

DataToolTip.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.string.isRequired,
  position: PropTypes.string,
};

export default memo(DataToolTip);
